<template>
    <div id="app" class="uk-container uk-position-relative">
        <div uk-sticky class="sticky-header">
            <img src="./assets/THS-logo-transparant.png" class="logo" @click="showProjectList"/>
        </div>
        <div v-if="state === 'loading'" class="uk-width-auto uk-margin-auto">
            <span uk-spinner="ratio: 2" />
        </div>

        <div
            v-if="state === 'error'"
            class="uk-card uk-card-default uk-card-body uk-margin-large-top uk-text-large no-assignment"
        >
            <b>{{ errorMessage }}</b>
        </div>

        <div
            v-if="state === 'noAssignments'"
            class="uk-card uk-card-default uk-card-body uk-margin-large-top uk-text-large no-assignment"
        >
           <b>Geen geplande opdrachten</b>
        </div>

        <project-list
            v-else-if="state === 'assignmentList'"
            :assignments="assignments"
            :constants="constants"
            @select-assignment="toSelectedAssignment"
        />

        <selected-assignment
            v-else-if="state === 'selectedAssignment'"
            :assignment="selectedAssignment"
            :token="token"
            :constants="constants"
            @started-assignment="toStartedAssignment"
            @error="showError"
        />

        <started-assignment
            v-else-if="state === 'startedAssignment'"
            :assignment="selectedAssignment"
            :registration="currentRegistration"
            :token="token"
            :constants="constants"
            @stop-assignment="toAssignmentList"
            @error="showError"
        />

    </div>
</template>

<style>
    @import url(~uikit/dist/css/uikit.css);

    html, body {
        background-color: #f8f8f8;
        height:           100%;
        min-height:       100%;
    }

    #app {
        font-family:             'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing:  antialiased;
        -moz-osx-font-smoothing: grayscale;
        color:                   #2c3e50;
        min-height:              100%;
        height:                  100%;
        text-align:              center;
    }

    .logo {
        width:  auto;
        margin: 50px auto;
    }

    .no-assignment {
        border-radius: 25px;
    }

    .sticky-header{
        background-color:  #f8f8f8;
    }

</style>

<script>
import 'uikit/dist/js/uikit';
import axios from 'axios';
import _ from 'lodash';

import ProjectList from './components/ProjectList';
import selectedAssignment from './components/SelectedAssignment';
import StartedAssignment from './components/StartedAssignment';

// ID's
const START_ACTIVITY_ID = Number(process.env.START_ACTIVITY_ID);
const STOP_ACTIVITY_ID  = Number(process.env.STOP_ACTIVITY_ID);
const WORK_TYPE_ID      = Number(process.env.WORK_TYPE_ID);

// URL's
const BASE_URL          = process.env.BASE_URL;
const GOOGLE_MAPS_URL   = process.env.GOOGLE_MAPS_URL;

// State values
const LOADING             = 'loading';
const NO_ASSIGNMENTS      = 'noAssignments';
const ASSIGNMENTS_LIST    = 'assignmentList';
const SELECTED_ASSIGNMENT = 'selectedAssignment';
const STARTED_ASSIGNMENT  = 'startedAssignment';
const ERROR               = 'error';

export default {
    name: 'app',

    data()
    {
        return {
            state:               LOADING,
            token:               '',
            assignments:         [],
            selectedAssignment:  {},
            currentRegistration: {},
            errorMessage:        '',
            constants: {
                START_ACTIVITY_ID,
                STOP_ACTIVITY_ID,
                WORK_TYPE_ID,
                GOOGLE_MAPS_URL,
            },
        };
    },

    methods: {
        async fetchAssignments() {
            try {
                let response = await axios.get(
                    '/timeRegistration.php',
                    {
                        params: {
                            action: 'assignments',
                            token:  this.token,
                        },
                    },
                );

                this.toAssignmentList(response.data.data);
            } catch (e) {
                this.showError('Fout opgetreden, opdrachten konden niet worden opgehaald');
            }
        },

        checkForStartedAssignment(assignments)
        {
            for (let assignment of assignments) {
                if (! assignment.timeRegistrations) {
                    continue;
                }

                for (let registration of assignment.timeRegistrations) {
                    if (registration.lastActivity === START_ACTIVITY_ID) {
                        return { assignment, registration };
                    }
                }
            }

            return null;
        },

        toSelectedAssignment(assignment) {
            this.selectedAssignment = assignment;
            this.state              = SELECTED_ASSIGNMENT;
        },

        toStartedAssignment(assignment, registration) {
            this.selectedAssignment  = assignment;
            this.currentRegistration = registration;
            this.state               = STARTED_ASSIGNMENT;
        },

        toAssignmentList(assignments) {
            this.assignments = _.filter(assignments, (assignment) => {
                if (! assignment.timeRegistrations) {
                    return true;
                }

                return ! _.every(assignment.timeRegistrations, [ 'lastActivity', STOP_ACTIVITY_ID ]);
            });

            if (_.isEmpty(this.assignments)) {
                this.state = NO_ASSIGNMENTS;
            } else {
                let startedAssignment = this.checkForStartedAssignment(this.assignments);

                if (startedAssignment) {
                    this.toStartedAssignment(startedAssignment.assignment, startedAssignment.registration);
                } else {
                    // No started assignment, show assignment list
                    this.state = ASSIGNMENTS_LIST;
                }
            }
        },

        showProjectList() {
            if (this.state != STARTED_ASSIGNMENT) {
                // No active registration, navigate back to project list
                window.location.href = BASE_URL + '?token=' + this.token;
            }
        },

        showError(message) {
            this.errorMessage = message;
            this.state        = ERROR;
        }
    },

    mounted () {
        this.token = (new URLSearchParams(document.location.search.substring(1))).get('token');

        this.fetchAssignments();
    },

    components: { StartedAssignment, selectedAssignment, ProjectList },
};
</script>
